import { useState } from 'react'
import {
  resolverDatasPeriodo,
  type TipoPeriodoPreset,
} from '../../../componentesCompartilhados/periodo/resolverDatasPeriodo'

/**
 * Estado do seletor de período (padrão do Faturamento) + função para resolver
 * o intervalo {dataInicio, dataFim} no momento da busca.
 */
export function usePeriodo(tipoInicial: TipoPeriodoPreset = 'ultimos30') {
  const hojeIso = new Date().toISOString().slice(0, 10)
  const [tipoPeriodo, setTipoPeriodo] = useState<TipoPeriodoPreset>(tipoInicial)
  const [dataReferencia, setDataReferencia] = useState(hojeIso)
  const [intervaloInicio, setIntervaloInicio] = useState('')
  const [intervaloFim, setIntervaloFim] = useState('')

  const resolver = () => resolverDatasPeriodo(tipoPeriodo, dataReferencia, intervaloInicio, intervaloFim)

  const seletorProps = {
    tipoPeriodo,
    onTipoPeriodoChange: setTipoPeriodo,
    dataReferencia,
    onDataReferenciaChange: setDataReferencia,
    intervaloInicio,
    intervaloFim,
    onIntervaloInicioChange: setIntervaloInicio,
    onIntervaloFimChange: setIntervaloFim,
  }

  const valores = { tipoPeriodo, dataReferencia, intervaloInicio, intervaloFim }

  return { seletorProps, resolver, valores }
}
